/**
 * Un téléphone ou une tablette : l'écran se commande au doigt (pas de souris, pas de survol). Le back-office n'y
 * fonctionne pas : qui a le portail terrain y va, les autres sont arrêtés.
 */
export function isMobileDevice() {
  try {
    return window.matchMedia('(pointer: coarse)').matches && window.matchMedia('(hover: none)').matches
  } catch (e) {
    return false
  }
}

/** Le portail terrain est ouvert à qui a sa permission. */
export function hasFieldPortal(user) {
  return (user?.permissions || []).includes('FIELD_PORTAL')
}

